import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const IllPage = lazyNamed(() => import('./pages'), 'IllPage');
const ErmPage = lazyNamed(() => import('./pages'), 'ErmPage');
const EventsPage = lazyNamed(() => import('./pages'), 'EventsPage');
const EventDetailPage = lazyNamed(() => import('./pages'), 'EventDetailPage');
const RoomsPage = lazyNamed(() => import('./pages'), 'RoomsPage');
const EngagementPage = lazyNamed(() => import('./pages'), 'EngagementPage');

/**
 * Staff routes for features/services. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const servicesRoutes: RouteObject[] = [
  { path: 'ill', element: <RequirePermission permission={['ill']}><IllPage /></RequirePermission> },
  { path: 'erm', element: <RequirePermission permission={['erm']}><ErmPage /></RequirePermission> },
  { path: 'events', element: <RequirePermission permission={['events']}><EventsPage /></RequirePermission> },
  { path: 'events/:id', element: <RequirePermission permission={['events']}><EventDetailPage /></RequirePermission> },
  { path: 'rooms', element: <RequirePermission permission={['events']}><RoomsPage /></RequirePermission> },
  { path: 'engagement', element: <RequirePermission permission={['clubs']}><EngagementPage /></RequirePermission> },
];
